import { spinnerClass } from "./spinner.css"

type SpinnerProps = {
  size?: "small" | "medium" | "large"
}

export function Spinner(props: SpinnerProps) {
  return <div class={spinnerClass({ size: props.size })} />
}
